import { render } from "./WizardFooter.vue?vue&type=template&id=1904c4aa&scoped=true"
import script from "./WizardFooter.vue?vue&type=script&lang=js"
export * from "./WizardFooter.vue?vue&type=script&lang=js"

import "./WizardFooter.vue?vue&type=style&index=0&id=1904c4aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1904c4aa"]])

export default __exports__